import ProjectCard from "./ProjectCard";

/**
 * Represents a list of project cards.
 *
 * @component
 * @param {Array} projects - Projects to render.
 */

const ProjectList = ({ projects }) => projects.map((project) => <ProjectCard key={project.id} project={project} />);

export default ProjectList;
